/** Common ignore patterns for Tix API errors. Use it to filter out expected HTTP errors to not pollute the error tracking. */
export const TIX_API_IGNORE_PATTERNS = [
  // 402: Payment not authorized (card declined, insufficient funds)
  new RegExp('^402 (Payment Required)?: POST /api/'),
  // 404: Resource not found (expected for some lookups)
  new RegExp('^404 (Not Found)?: GET /cached_api/'),
  new RegExp('^404 (Not Found)?: GET /api/'),
  new RegExp('^404 (Not Found)?: POST /api/'),
  // 409: Resource conflict (duplicate email, name collision)
  new RegExp('^409 (Conflict)?: POST /api/'),
  // 410: Resource expired (cart/session no longer available)
  new RegExp('^410 (Gone)?: POST /api/'),
  // 422: Validation error (invalid input data)
  new RegExp('^422 (Unprocessable Entity)?: POST /api/'),
  // 401: Invalid credentials (login/checkout password failures)
  new RegExp('^401 (Unauthorized)?: POST /api/login'),
  new RegExp('^401 (Unauthorized)?: POST /api/user'),
]
